module.exports = require('./helpers/bundle-url').getBundleURL('hmjwG') + "vmware_vsphere-logo.86c962ec.png";